import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCandles = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "124px",
	height: "124px",
	viewBox: "0 0 124 124",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [/* @__PURE__ */ _jsx("title", { children: "Group 17" }), /* @__PURE__ */ _jsx("g", {
		id: "Memorial-Day",
		stroke: "none",
		strokeWidth: 1,
		fill: "none",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsx("g", {
			transform: "translate(-450.000000, -135.000000)",
			id: "Group-17",
			stroke: "currentcolor",
			strokeWidth: 4,
			children: /* @__PURE__ */ _jsxs("g", {
				transform: "translate(452.000000, 140.000000)",
				children: [/* @__PURE__ */ _jsx("polygon", {
					id: "Stroke-1",
					points: "69.0948947 101.804526 92.5754211 101.804526 92.5754211 68.7303158 92.5754211 49.0929474 69.0948947 49.0929474 69.0948947 69.7645263"
				}), /* @__PURE__ */ _jsxs("g", {
					id: "Group-16",
					children: [
						/* @__PURE__ */ _jsx("path", {
							d: "M92.9317895,68.0861053 C91.8028421,67.134 90.0407368,65.9482105 87.7828421,65.6876842 C84.5917895,65.3197895 82.6544211,67.0613684 79.5454737,68.0861053 C77.2717895,68.8361053 73.8786316,69.3650526 69.2475789,68.0861053",
							id: "Stroke-2"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M83.3928947,14.5001053 C83.3928947,14.5001053 81.5502632,23.3864211 87.6923684,28.8558947 C93.8344737,34.3253684 74.7939474,45.9464211 72.9513158,34.3253684 C71.1071053,22.7027368 83.3928947,14.5001053 83.3928947,14.5001053 Z",
							id: "Stroke-4"
						}),
						/* @__PURE__ */ _jsx("polygon", {
							id: "Stroke-6",
							points: "57.3738947 105.099 27.6312632 105.099 27.6312632 62.7232105 27.6312632 37.5611053 57.3738947 37.5611053 57.3738947 64.0463684"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M28.9845789,65.3412632 C30.4135263,64.1475789 32.6461579,62.6602105 35.5056316,62.3333684 C39.5493158,61.8723158 42.003,64.056 45.9408947,65.3412632 C48.8208947,66.2807368 53.1187895,66.9454737 58.9845789,65.3412632",
							id: "Stroke-8"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M39.6491053,0 C39.6491053,0 41.7048947,9.91578947 34.8522632,16.0168421 C27.9980526,22.1194737 49.2443684,35.0842105 51.3001579,22.1194737 C53.3559474,9.15315789 39.6491053,0 39.6491053,0 Z",
							id: "Stroke-10"
						}),
						/* @__PURE__ */ _jsx("polyline", {
							id: "Stroke-12",
							points: "18.9473684 95.2154211 0 100.157526 0 116.052789 74.2105263 116.052789"
						}),
						/* @__PURE__ */ _jsx("polyline", {
							id: "Stroke-14",
							points: "101.052632 95.2154211 120 100.157526 120 116.052789 45.7894737 116.052789"
						})
					]
				})]
			})
		})
	})]
});
export default SvgCandles;
